
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.209 10c0 .724.534 1.312 1.191 1.312.331 0 .6.296.6.66v2.379C18 16.363 16.514 18 14.686 18H5.314C3.486 18 2 16.363 2 14.351v-2.378c0-.365.269-.66.6-.66.657 0 1.191-.589 1.191-1.312 0-.705-.512-1.236-1.191-1.236a.573.573 0 01-.424-.193A.697.697 0 012 8.105V5.648C2 3.636 3.489 2 5.316 2h9.37c1.827 0 3.314 1.636 3.314 3.648L18 8.028a.697.697 0 01-.176.468.573.573 0 01-.424.193c-.657 0-1.191.588-1.191 1.312zm-4.159.655l1.008-1.02a.668.668 0 00.16-.676.633.633 0 00-.51-.446l-1.392-.211-.624-1.312a.628.628 0 00-.566-.367h-.001a.63.63 0 00-.567.366l-.623 1.313-1.39.21a.637.637 0 00-.513.447c-.076.24-.015.5.16.675l1.008 1.02-.238 1.444a.666.666 0 00.252.644c.111.083.24.126.371.126.1 0 .201-.027.293-.077l1.247-.681 1.244.68c.215.119.47.1.666-.049a.663.663 0 00.254-.643l-.239-1.443z","fill":"#94A3B8"}})])
          )
        }
      }
    